import { useSyncOfflineDataMutation } from "../../../services/api/offlineApi";
import { useDispatch, useSelector } from "react-redux";
import {
  clearFailedRequests,
  selectFailedRequests,
} from "../../../store/slices/failedRequests";
import { setIsSyncingLoading } from "../../../store/slices/network";
import { useEffect, useRef } from "react";
import { selectHasToken } from "../../../store/slices/authorisation";

export function useSyncOfflineRequests() {
  const [triggerSyncOfflineData, { isLoading }] = useSyncOfflineDataMutation();
  const failedRequests = useSelector(selectFailedRequests);
  const dispatch = useDispatch();
  const hasMounted = useRef(false);

  const isAuthenticated = useSelector(selectHasToken);

  useEffect(() => {
    hasMounted.current = true;
  }, []);

  useEffect(() => {
    dispatch(setIsSyncingLoading(isLoading));
  }, [isLoading]);

  const syncOfflineRequests = async () => {
    if (!hasMounted.current || !isAuthenticated || !failedRequests.length)
      return;

    try {
      await triggerSyncOfflineData({ data: failedRequests }).unwrap();
      dispatch(clearFailedRequests());
    } catch (error) {
      console.error(error);
    }
  };

  return { syncOfflineRequests };
}
